export enum RequestStatus {
    pending,
    rejected,
    fulfilled
}